
interface IKnovioConnectionPreviewLinkDTO extends IKnovioPreviewLinkDTO {
    meetingConnectionId: number | string;
}

interface IKnovioArtifactPreviewLinkDTO extends IKnovioPreviewLinkDTO {
    assetMetadataId: number | string;
    meetingId: number | string;
}
interface IKnovioPreviewLinkDTO {
    accountId: number;
    eventId: number;
    expirationDate: Date;
}

interface IKnovioPreviewLinkResponse {
    id: number;
    idHash: string;
    presentationLink: string;
}

abstract class IKnovioPreviewLinkDAO {
    public abstract generateKnovioConnectionPreviewLink (
        params: IKnovioConnectionPreviewLinkDTO,
        cancelRequestSignal?: AbortSignal
    ): Promise<IKnovioPreviewLinkResponse>;

    public abstract generateKnovioArtifactPreviewLink (
        params: IKnovioArtifactPreviewLinkDTO,
        cancelRequestSignal?: AbortSignal
    ): Promise<IKnovioPreviewLinkResponse>;
}

export { IKnovioPreviewLinkDAO, IKnovioConnectionPreviewLinkDTO, IKnovioArtifactPreviewLinkDTO, IKnovioPreviewLinkResponse };
